var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeCalenderDesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 718,
    height: 500,
    viewBox: "0 0 718 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-150 -293)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 718,
    height: 500,
    transform: "translate(150 293)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-close",
    d: "M4.926,3.99A.936.936,0,0,0,4.274,5.6l5.89,5.89-5.89,5.89A.936.936,0,1,0,5.6,18.7l5.89-5.89,5.89,5.89A.936.936,0,1,0,18.7,17.378l-5.89-5.89L18.7,5.6a.936.936,0,1,0-1.324-1.324l-5.89,5.89L5.6,4.274A.936.936,0,0,0,4.926,3.99Z",
    transform: "translate(832.209 757.345)",
    fill: "coral"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-close-2",
    "data-name": "icons8-close",
    d: "M.624,0A.624.624,0,0,0,.189,1.072L4.116,5,.189,8.925a.624.624,0,1,0,.882.882L5,5.881,8.925,9.808a.624.624,0,1,0,.882-.882L5.88,5,9.807,1.072A.624.624,0,1,0,8.925.189L5,4.116,1.071.189A.624.624,0,0,0,.624,0Z",
    transform: "translate(217.62 304.593) rotate(45)",
    fill: "coral"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-close-3",
    "data-name": "icons8-close",
    d: "M4.614,3.99a.624.624,0,0,0-.435,1.071L8.106,8.988,4.179,12.915a.624.624,0,1,0,.882.882L8.988,9.871,12.915,13.8a.624.624,0,1,0,.882-.882L9.871,8.988,13.8,5.061a.624.624,0,1,0-.882-.882L8.988,8.106,5.062,4.179A.624.624,0,0,0,4.614,3.99Z",
    transform: "translate(683.074 709.143)",
    fill: "#343a54"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(791 675)",
    fill: "#343a54"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(404 293)",
    fill: "coral"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-close-4",
    "data-name": "icons8-close",
    d: "M.936,0A.936.936,0,0,0,.283,1.607L6.173,7.5l-5.89,5.89a.936.936,0,1,0,1.324,1.324L7.5,8.821l5.89,5.89a.936.936,0,1,0,1.324-1.324L8.821,7.5l5.89-5.89A.936.936,0,1,0,13.387.284L7.5,6.174,1.607.284A.936.936,0,0,0,.936,0Z",
    transform: "translate(329.5 343) rotate(45)",
    fill: "#343a54"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCalenderDesign);
export default __webpack_public_path__ + "static/media/homeCalenderDesign.bf2b88b90cbc5fc51557ed9ff2956fc8.svg";
export { ForwardRef as ReactComponent };